import { useRecoilState } from "recoil";
import { modalVisibleState } from "recoils/common/commonState";

const useModal = () => {
  const [visibleModal, setVisibleModal] = useRecoilState(modalVisibleState);
  const closeModal = () => {
    setVisibleModal((prev) => ({
      ...prev,
      isopen: false,
    }));
  };
  const openModal = (type, name, data) => {
    setVisibleModal((prev) => {
      const newState = {
        ...prev,
        isopen: true,
        modalType: type,
        modalName: name,
        ...(data && { data }), // data가 존재하면 추가
      };
      return newState;
    });
  };

  return {
    visibleModal,
    closeModal,
    openModal,
  };
};
export default useModal;
